export function isObject(val: unknown): val is object {
  return typeof val === 'object' && val !== null && !Array.isArray(val);
}

/**
 * Tests two values for equality. Primitive values are done using a basic value & type test of ===.
 * For objects and arrays, all array members or object properties in the value argument are tested
 * against the corresponding member/property in the expected argument with this function, recursively.
 * Any field present in expected but not in value is ignored.
 *
 * That is, this allows to test if `{ id: "example" }` matches `{ id: "example": more: "data", foo: "bar" }`
 * without having to specify all the fields present in the expected value.
 * @param expected
 * @param value
 * @returns
 */
export function valueEquals(expected: unknown, value: unknown): boolean {
  if (Array.isArray(value) && Array.isArray(expected)) {
    return value.every((v, i) => valueEquals(expected[i], v));
  } else if (isObject(value) && isObject(expected)) {
    return Object.entries(value).every(([key, v]) => {
      // Make sure the expected object has the key in the first place.
      if (!Object.hasOwn(expected, key)) return false;
      // @ts-expect-error no idea what these types are
      return valueEquals(expected[key], v);
    });
  }
  if (Number.isNaN(expected) && Number.isNaN(value)) return true;
  return expected === value;
}
